<template>
  <div id="app" :class="[lang, isAgencyAgentLogin && 'has-background', kindBonauf]" :style="{backgroundColor: backgroundColor}">
    <Container v-if="categoryList && !!whiteLabel" />
    <ContentLoading
      v-if=" ((!categoryList || categoryList && categoryList.length == 0) && isAgency ) || isProcessingBooking"
      type="app"
    />
    <b-modal
      id="processingBooking"
      centered
      size="lg"
      :dir="lang === 'he' ? 'rtl' : 'ltr'"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-footer="true"
    >
      <template #toast-title>
        <div class="d-flex flex-grow-1 align-items-baseline" :dir="lang==='he' ? 'rtl' : 'ltr'">
          <h3>{{ $t('booking.waiting') }}</h3>
        </div>
      </template>
      <div class="d-flex">
        <h5>{{ $t('booking.waiting-populating') }}</h5>
        <img src="/assets/img/waiting.gif" width="100" height="100" alt="waiting"/>
      </div>
    </b-modal>
    <b-modal
      id="statusSite"
      centered
      size="lg"
      :dir="lang === 'he' ? 'rtl' : 'ltr'"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-footer="true"
      :title="statusTitle"
    >
      <div :class="[lang == 'he' ? 'text-right' : 'text-left']" :dir="lang==='he' ? 'rtl' : 'ltr'" v-html="statusMessage"></div>
    </b-modal>
    <NotifyPopup :open="showNotify" @close="showNotify = false" :content="popupContent" v-if="showNotifyPopup"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { loadProgressBar } from 'axios-progress-bar';
import 'axios-progress-bar/dist/nprogress.css';
import { BModal } from 'bootstrap-vue';
import dayjs from 'dayjs';
import googleAnalytics from '@/utils/googleAnalytics';
import bannerImageDestination from '@/utils/bannerImageDestination';
import imageUrlMixin from '@/utils/imageUrlMixin';
// import { getTypeStatusSite } from '@/utils/constant';

const { VUE_APP_LANDING_PAGE_KEY, VUE_APP_CHANNEL_MOBILE_APP, VUE_APP_STAGING_DOMAIN } = process.env;

export default {
  name: 'App',
  components: {
    BModal,
    ContentLoading: () => import('@/components/atoms/ContentLoading'),
    Container: () => import('@/components/Container'),
    NotifyPopup: () => import('@/components/NotifyPopup'),
  },
  mixins: [googleAnalytics, imageUrlMixin, bannerImageDestination],
  metaInfo() {
    const { name, query } = this.$route;
    const metaInfoData = [];
    let title = '', destination = '', dealType = '', departure = '', hotel = '';
    const production = JSON.parse(window.sessionStorage.getItem('production'));
    if (production) {
      dealType = this.getDealTypeName(window.sessionStorage.getItem('dealType'));
      departure = dayjs(production.fromDate).format('YYYY-MM-DD');
      destination = production.destination_1_name;
      title = `   ${dealType} ל ${destination} - ${departure}`;
      if (production?.translations?.hotelName && (name === 'booking-hotel-flight' || name === 'booking-flight' || name === 'verifying-card' || name === 'card-verified')) {
        // hotel = production?.translations?.hotelName?.[production.hotel[0].hotelId]?.en || production?.translations?.hotelName?.[production.hotel[0].hotelId]?.he;
        const hotelId = Number(production.hotels[0].La_ID);
        hotel = production?.translations?.hotelName?.[hotelId]?.en || production?.translations?.hotelName?.[hotelId]?.he;
        title += ` - ${hotel}`;
      }
    }

    let destList = [], strDestination = ''; // hotel list
    switch (name) {
      case 'home': case 'slug-info':
        destination = query[VUE_APP_LANDING_PAGE_KEY];
        if (destination === undefined || !destination) {
          title = 'בוא נעוף-דילים מטורפים בכל יום';
          window.prerenderReady = true;
        } else {
          destination = this.landingDealData[0]?.destinationName?.[this.lang];
          title = `השטיח המעופף חבילות נופש ל ${destination}`;
          if (this.landingDealData[0]?.destinationName) { window.prerenderReady = true; }
        }
        break;
      case 'booking-hotel-flight': case 'booking-flight':
        title = `השטיח המעופף עמוד תשלום${title}`;
        window.prerenderReady = true;
        break;
      case 'verifying-card':
        title = `השטיח המעופף  עמוד חיוב${title}`;
        window.prerenderReady = true;
        break;
      case 'card-verified':
        title = `השטיח המעופף  עמוד אישור${title}`;
        window.prerenderReady = true;
        break;
      case 'destination-list':
        if (query.packCategory === 'vacation_pack') {
          title = 'השטיח המעופף | מדריך היעדים';
        }
        if (query.packCategory === 'Flight_Only') {
          title = 'השטיח המעופף | טיסות';
        }
        if (query.packCategory === 'Organize_tour_packages') {
          title = 'השטיח המעופף | טיולים מאורגנים';
        }
        window.prerenderReady = true;
        break;
      case 'hotel-list':
        destList = decodeURIComponent(query.dest).split(',') ?? [];
        strDestination = destList.map((dest) => this.listDestinations?.[query.packCategory]?.find((d) => (d.code === dest))?.name?.he ?? dest).join(',');
        if (query.packCategory === 'vacation_pack') {
          title = `השטיח המעופף | מלונות ב ${strDestination}`;
        }
        if (query.packCategory === 'Flight_Only') {
          title = `השטיח המעופף | טיסות ל ${strDestination}`;
        }
        if (query.packCategory === 'Organize_tour_packages') {
          title = `השטיח המעופף | טיולים מאורגנים ${strDestination}`;
        }
        if (this.listDestinations) { window.prerenderReady = true; }
        break;
      case 'shareAppLink': case 'home-app': case 'deal-filter-app': case 'deal-tab-app':
      case 'booking-hotel-flight-app': case 'booking-flight-app': case 'card-verified-app':
      case 'deal-filter-desktop': case 'deal-tab-desktop':
        title = 'בוא נעוף-דילים מטורפים בכל יום';
        // metaInfoData.push({ name: 'description', content: 'בכל יום דיל חדש, בכל יום הזדמנות חדשה לחופשה|טיסות ישירות וחבילות נופש ליעדים הכי חמים שיש' });
        // metaInfoData.push({ property: 'og:description', content: 'ברוכים הבאים לדף הרשמי של אפליקציית בוא נעוף. כל מה שנשאר לכם לעשות הוא להוריד את האפליקציה ולבחור בימי רביעי...' });
        // metaInfoData.push({ property: 'og:title', content: 'בוא נעוף אפליקציה - אפליקציית תיירות, הדף הרשמי' });
        // metaInfoData.push({ property: 'og:site_name', content: 'בוא נעוף אפליקציה - אפליקציית תיירות, הדף הרשמי' });
        // metaInfoData.push({ name: 'keywords', content: 'בא נעוף' });
        // console.log(metaInfoData);
        window.prerenderReady = true;
        break;
      case 'search-result':
        destList = decodeURIComponent(query.dest).split(',') ?? [];
        dealType = this.getDealTypeName(query.categoryId);
        destination = destList.map((dest) => this.category?.destinations?.find((item) => item.code === dest)?.name[this.lang] || dest).join(',');
        title = `תוצאות חיפוש: ${dealType} ${destination} ${query.fromDate} ~ ${query.toDate}`;

        document.querySelector('head meta[property="og:image"]').setAttribute('content', this.bannerImage);
        if (this.category) { window.prerenderReady = true; }
        break;
      case 'product-page': case 'product-page-web': case 'product-page-old-app': case 'product-page-app': case 'product-page-app-desktop':
        destination = this.product?.destination_1_name || '';
        dealType = this.getDealTypeName(query.categoryId);
        departure = query.dateFrom;
        hotel = this.product?.translations?.hotelName?.[query.laId]?.en || this.product?.translations?.hotelName?.[query.laId]?.he;
        title = `השטיח המעופף   ${dealType} ל ${destination} - ${departure} - ${hotel}`;

        document.querySelector('head meta[property="og:title"]').setAttribute('content', title);
        document.querySelector('head meta[property="og:description"]').setAttribute('content', destination);
        document.querySelector('head meta[property="og:image"]').setAttribute('content', this.product?.perspectiveUrls?.[0] || this.product?.galleryUrls?.[0] || this.product?.productContent?.imageUrls?.[0] || this.bannerImage);
        // if (this.product) { window.prerenderReady = true; }
        break;
      case 'flight-only': case 'flight-only-web': case 'flight-only-old-app': case 'flight-only-app': case 'flight-only-app-desktop':
        destination = this.product?.destination_1_name || '';
        dealType = this.getDealTypeName(query.categoryId);
        departure = query.dateFrom;
        title = `השטיח המעופף   ${dealType} ל ${destination} - ${departure}`;

        document.querySelector('head meta[property="og:image"]').setAttribute('content', this.bannerImage);
        // if (this.product) { window.prerenderReady = true; }
        break;
      default:
    }

    if (this.marketerId !== '') {
      title = this.agencyMarketerContent?.metaTitle ?? title;
      // this.setBackgroundColor(this.agencyMarketerContent?.backgroundColorCss ?? 'white');
    } else if (this.whiteLabel && !this.whiteLabel.forMainSite) {
      title = this.whiteLabel?.metaTitle ?? title;
      // this.setBackgroundColor(this.whiteLabel?.backgroundColorCss ?? 'white');
    }

    document.title = title;
    const origin = window.location.href;
    document.querySelector('head meta[property="og:url"]').setAttribute('content', origin);

    if (this.isDesktopApp) {
      // document.querySelector('head meta[property="og:title"]').setAttribute('content', 'בוא נעוף-דילים מטורפים בכל יום');
      // document.querySelector('head meta[property="og:site_name"]').setAttribute('content', 'בוא נעוף - דילים מטורפים בכל יום');
      // document.querySelector('head meta[name="keywords"]').setAttribute('content', 'כל יום דיל חדש  ,כל יום יעד חדש  ,  בוא נעוף');
      // document.querySelector('#icon-tab').href = 'https://flying.co.il/assets/img/bonaufLink.png';

      // const bonaufAppDescription = 'בכל יום דיל חדש, בכל יום הזדמנות חדשה לחופשה|טיסות ישירות וחבילות נופש ליעדים הכי חמים שיש';
      // document.querySelector('head meta[property="og:description"]').setAttribute('content', bonaufAppDescription);
      // document.querySelector('head meta[name="description"]').setAttribute('content', bonaufAppDescription);
      // metaInfoData.push({ name: 'description', content: bonaufAppDescription });
      // metaInfoData.push({ property: 'og:description', content: bonaufAppDescription });
    } else if (!this.isRegularSite) {
      metaInfoData.push({ name: 'description', content: this.metaDescriptionMarketer });
    }

    return {
      title,
      meta: metaInfoData,
      url: origin,
      script: [
        { src: 'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js', async: true, defer: true },
      ],
    };
  },
  data() {
    return {
      isAgency: true,
      count: 0,
      shownStatusMessage: false,
      statusTitle: '',
      statusMessage: '',
      showNotify: true,
      popupContent: '',
      loadStartupPopup: true,
    };
  },
  computed: {
    ...mapGetters({
      device: 'GET_DEVICE',
      statusSite: 'GET_STATUS_MESSAGE',
      isAppDealPage: 'GET_IS_APP_DEAL_PAGE',
      isLanding: 'GET_IS_LANDING_PAGE',
      isProcessingBooking: 'GET_PROCESSING_BOOKING_STATE',
      landingDealData: 'GET_LANDING_DEAL_DATA',
      landingInfo: 'GET_LANDING_INFO',
      lang: 'GET_LANGUAGE',
      packages: 'GET_PACKAGES',
      category: 'GET_CURRENT_CATEGORY',
      product: 'GET_PRODUCT',
      searchContent: 'GET_SEARCH_CONTENT',
      whiteLabel: 'GET_WHITE_LABEL_DATA',
      agencyMarketerContent: 'GET_MARKETER_AGENCY_CONTENT',
      listDestinations: 'GET_LANDING_DESTINATIONS',
      marketerId: 'GET_MARKETER_ID',
      categoryList: 'GET_CATEGORIES',
      typeChannel: 'GET_TYPE_CHANNEL',
      calendarData: 'GET_CALENDAR_DATA',
      isAgencyAgentLogin: 'IS_AGENCY_AUTHORIZED',
      isAgencyLoginState: 'GET_AGENCY_LOGIN_STATE',
      isOdysseySite: 'GET_ODYSSEY_AGENT_STATE',
      privateMessage: 'GET_PRIVATE_MESSAGE',
      sharedMessage: 'GET_SHARED_MESSAGE',

      isDesktopApp: 'GET_BONAUF_DESKTOP_APP',
      isMaccabiAgency: 'GET_IS_MACCABI_AGENCY',
    }),
    urlParams() {
      let match;
      const pl = /\+/g,
        search = /([^&=]+)=?([^&]*)/g,
        decode = (s) => decodeURIComponent(s.replace(pl, ' ')),
        query = window.location.search.substring(1);
      const urlParams = {};
      // eslint-disable-next-line no-cond-assign
      while ((match = search.exec(query))) urlParams[decode(match[1])] = decode(match[2]);

      return urlParams;
    },
    isMobileApp() {
      return this.typeChannel === VUE_APP_CHANNEL_MOBILE_APP;
    },
    isRegularSite() {
      return this.marketerId !== '' && this.whiteLabel !== null;
    },
    metaDescriptionMarketer() {
      let description = '';
      if (this.marketerId) {
        description = this.agencyMarketerContent?.metaDescription ?? '';
      } else {
        description = this.whiteLabel?.metaDescription ?? '';
      }
      return description;
    },
    backgroundColor() {
      let color = 'transparent';
      if (this.marketerId !== '') {
        color = this.agencyMarketerContent?.backgroundColorCss ?? 'white';
      } else if (this.whiteLabel && !this.whiteLabel.forMainSite) {
        color = this.whiteLabel?.backgroundColorCss ?? 'white';
      }
      return color;
    },
    kindBonauf() {
      return this.device === 'mobile' ? 'bonauf-mobile' : 'bonauf-desktop';
    },
    showNotifyPopup() {
      return this.$route.path.startsWith('/deal-filter/') && this.popupContent !== '';
    },
  },
  watch: {
    $route: {
      immediate: true,
      async handler(to) {
        if (this.$route.name !== null) {
          this.$store.commit('SET_TYPE_CHANNEL', to.query?.channel || '');
          this.$store.dispatch('STORE_APP_DEAL_URL', to);
          if (this.$route.query.marketerId === undefined || this.$route.query.marketerId === '' || this.$route.query.channel === VUE_APP_CHANNEL_MOBILE_APP) {
            const idGtag = 'GTM-MKMRMKB';
            // window.onesignal_sdk_is_integrated = false;
            // eslint-disable-next-line func-names
            (function (w, d, s, l, i) {
              w[l] = w[l] || []; w[l].push(
                {
                  'gtm.start': new Date().getTime(),
                  event: 'gtm.js',
                },
              );

              const f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l !== 'dataLayer' ? `&l=${l}` : '';

              j.async = true; j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
              f.parentNode.insertBefore(j, f);
            }(window, document, 'script', 'dataLayer', idGtag));
          }

          const gtagID = this.$route.query.channel === VUE_APP_CHANNEL_MOBILE_APP ? 'UA-217589800-1' : 'UA-236052724-1';
          const gtagScript = document.createElement('script');
          gtagScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${gtagID}`);
          document.head.appendChild(gtagScript);
          window.dataLayer = window.dataLayer || [];
          this.gtag('js', new Date());
          this.gtag('config', gtagID);

          // const gtagIDGA4 = 'G-Y4T1ZHCTXH';
          // const gtagScriptGA4 = document.createElement('script');
          // gtagScriptGA4.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${gtagIDGA4}`);
          // document.head.appendChild(gtagScriptGA4);
          // window.dataLayer = window.dataLayer || [];
          // this.gtag('js', new Date());
          // this.gtag('config', gtagIDGA4);
        }

        const accessibility = document.querySelector('.accessibility_component > a.btn_accessibility.accessibility_component');
        if (accessibility) {
          if (to.query?.channel === 'App' && !this.isDesktopApp) {
            accessibility.style.display = 'none';
          } else {
            accessibility.style.display = 'block';
          }
        }

        this.shownStatusMessage = false;
        this.showStatusMessage(to);
      },
    },
    statusSite() {
      this.showStatusMessage(this.$route);
    },
    product() {
      const to = this.$route;
      if (to.name !== 'home') {
        const destination = this.product.destination_1_name,
          dealType = this.getDealTypeName(to.query.categoryId),
          departure = to.query.dateFrom,
          hotel = this.product?.translations?.hotelName?.[to.query.laId]?.en || this.product?.translations?.hotelName?.[to.query.laId]?.he;
        switch (to.name) {
          case 'product-page': case 'flight-only':
            document.title = `השטיח המעופף   {${dealType}} ל {${destination} - ${departure} - ${hotel}}`;
            break;
          default:
        }
      }
    },
    isProcessingBooking() {
      if (this.isProcessingBooking) {
        this.$bvModal.show('processingBooking');
      } else {
        this.$bvModal.hide('processingBooking');
      }
    },
    categoryList() {
      this.$store.dispatch('UPDATE_CURRENT_CATEGORY', { categoryId: this.categoryList[0].dealTypeCode });
    },
    isAgencyLoginState() {
      if (this.isAgencyAgentLogin) {
        window.location.reload();
      }
    },
    isAgencyAgentLogin() {
      if (this.isAgencyAgentLogin) {
        this.$store.dispatch('SOCKET_PRIVATE_CONNECT', this);
        this.$store.dispatch('SOCKET_SHARED_CONNECT', this);
      } else {
        this.$store.dispatch('SOCKET_DIS_CONNECT', this);
      }
    },
    privateMessage() {
      this.showAdminMessageForAgent(this.privateMessage, 'private');
    },
    sharedMessage() {
      this.showAdminMessageForAgent(this.sharedMessage, 'shared');
    },
  },
  methods: {
    showStatusMessage(to) {
      const { location } = window, pageName = to.path;
      if (pageName === location.pathname) {
        if (this.statusSite && this.statusSite?.active && this.statusSite?.target?.package?.length > 0) {
          const pages = this.statusSite.target.package;
          const showStatusMessageSite = pages.includes('allPages') || pages.includes(to.name);
          if (showStatusMessageSite && !this.shownStatusMessage) {
            this.statusTitle = this.statusSite.message?.title ?? '';
            this.statusMessage = this.statusSite.message?.body ?? '';
            this.$bvModal.show('statusSite');
            this.shownStatusMessage = true;
          }
        }
      }
    },
    resize() {
      // let device = 'desktop';
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      // const { offsetWidth } = document.getElementById('app');
      // if (isMobile) {
      //   device = 'mobile';
      // } else {
      //   device = 'desktop';
      // }
      this.$store.dispatch('UPDATE_DEVICE', isMobile ? 'mobile' : 'desktop');
    },
    async sendMailError(pStage, pResponse) {
      const body = `<h3>${pStage}</h3></Br>
        <div><pre>${pResponse}</pre></div>
        `;
      const notification = {
        subject: `${pStage}`,
        body,
      };
      await this.$store.dispatch('NOTIFY_ADMIN', notification);
    },
    getDealTypeName(pCode) {
      let name = pCode;
      switch (pCode) {
        case 'vacation_pack':
          name = 'חבילות נופש';
          break;
        case 'Organize_tour_packages':
          name = 'טיולים מאורגנים';
          break;
        case 'Flight_Only':
          name = 'טיסות בלבד';
          break;
        default:
      }
      return name;
    },
    async getSetSomeParameter() {
      this.$store.commit('SET_FC_AGENT_MARKETER_MODE', this.urlParams['fc-agent-mode'] !== undefined);

      // set MargeterId
      const marketerId = this.urlParams?.marketerId ? this.urlParams?.marketerId : '';
      if (marketerId !== '') {
        this.$store.commit('SET_MARKETER_ID', marketerId);
        await this.$store.dispatch('FETCH_AGENCY_FROM_MARKETER_ID');
      }

      this.$store.commit('SET_HOME_LINK', this.urlParams);
    },
    showAdminMessageForAgent(messageBody, type) {
      const h = this.$createElement;
      const messageContent = h('div', {
        domProps: {
          innerHTML: messageBody,
        },
      });
      const id = `${type}-${this.count += 1}`;
      const closeButton = h(
        'b-button',
        {
          props: { variant: 'primary', size: 'sm' },
          on: { click: () => this.$bvToast.hide(id) },
        },
        'Close',
      );
      this.$bvToast.toast([messageContent, closeButton], {
        id,
        title: `${type} message`,
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-top-center',
        bodyClass: ['text-right', 'message-content'],
        noCloseButton: true,
      });
    },
    getShareData(data) {
      document.querySelector('head meta[property="og:title"]').setAttribute('content', this.getShareTitleDesc('title', data));
      document.querySelector('head meta[property="og:description"]').setAttribute('content', this.getShareTitleDesc('description', data));
      window.prerenderReady = true;
    },
    getShareTitleDesc(kind, data) {
      const { category, dest, hotel, airline, duration, country, rate } = data;
      let title = '';
      if (category === 'vacation_pack') {
        title = this.$t(`share-this.vacation_pack-${kind}`, { dest, hotel, duration, rate });
      } else if (category === 'Organize_tour_packages') {
        title = this.$t(`share-this.Organize_tour_packages-${kind}`, { country, duration, rate });
      } else if (category === 'Flight_Only') {
        title = this.$t(`share-this.Flight_Only-${kind}`, { dest, airline, duration, rate });
      } else if (category === 'SportPack') {
        title = this.$t(`share-this.SportPack-${kind}`, { dest, hotel, duration, rate });
      } else {
        title = '';
      }

      return title;
    },
  },
  async beforeCreate() {
    /**
     * test link:
     * https://www.flying.co.il/?destination=HER&utm_source=google
     * https://www.flying.co.il/?destination=LCA&utm_source=google&dealtype=Organize_tour_packages
     * https://www.flying.co.il/?destination=PFO&utm_source=google&dealtype=Flight_Only
     * https://www.flying.co.il/?destination=AYT&utm_source=google&dealtype=vacation_pack
     */
  },
  async created() {
    let { host } = window.location;

    await this.$store.dispatch('FETCH_STATUS_MESSAGE');

    if (window.location.pathname === '/redirect-verified') {
      const marketerId = window.parent?.sessionStorage?.getItem('marketerId');
      const typeChannel = window.parent?.sessionStorage?.getItem('typeChannel');
      const paramFcAgentMode = window.parent?.localStorage?.getItem('fcAgentMode');
      this.$store.commit('SET_MARKETER_ID', marketerId);
      let path = window.location.href.replace('redirect-verified', 'booking/card-verified');
      path += `&channel=${typeChannel}`;
      if (marketerId !== '') path += `&marketerId=${marketerId}`;

      // await this.sendMailError(
      //   'Trace email to check the redirection URL: ResponseCR2k',
      //   JSON.stringify({ title: 'ResponseCR2k URL at inner iframe', responseCR2K: decodeURIComponent(path), currPath: decodeURIComponent(window.location.href) }),
      // );

      window.parent.postMessage(`${path}${paramFcAgentMode}`, '*');
      return;
    }
    window.addEventListener('resize', this.resize);

    if (host.includes('localhost')) {
      await this.$store.commit('SET_MODE', true);
      await this.$store.commit('SET_STAGING_MODE', true);
      await this.$store.commit('SET_TEST_MODE', true);
    }
    if (host.includes(VUE_APP_STAGING_DOMAIN)) {
      await this.$store.commit('SET_STAGING_MODE', true);
    }

    if (host.includes('localhost') || host.includes('vercel')){
      host = 'www.bonauf.co.il';
    }

    const response = await this.$store.dispatch('FETCH_WHITE_LABEL', host);

    const firstPathname = new URL(window.location.href).pathname.split('/')[1];
    if (firstPathname === 'shared') {
      const reverseUrl = await this.$store.dispatch('FETCH_REVERSE_URL', { shortenedUrl: window.location.pathname });
      if (reverseUrl) {
        window.location.href = reverseUrl;
      } else {
        window.location.href = window.location.origin;
      }
    }

    await this.getSetSomeParameter();

    if (response?.data?.status !== 404) {
      this.$store.dispatch('FETCH_CATEGORIES_LIST');
      this.$store.dispatch('FETCH_DESTINATION_IMAGES');
      this.$store.dispatch('FETCH_FOOTER_PAGES_LIST');
      if (this.loadStartupPopup) {
        const responseData  = await this.$store.dispatch('FETCH_STRING_CONTENTS', { itemId: 'startup', pageId: 'bonaufHome'});
        if(responseData?.caption_Loc?.content){
          this.popupContent = responseData.caption_Loc.content;
        }
      }
    } else {
      this.isAgency = false;
    }
  },
  mounted() {
    this.$root.$on('send-share-data', this.getShareData);
    this.resize();
    loadProgressBar({ showSpinner: false });

    window.addEventListener('message', (event) => {
      const { data } = event;
      if (typeof data === 'string' && (data.includes('booking/card-verified'))) {
        const url = new URL(data);
        // this.sendMailError(
        //   'Trace email to check the redirection URL: ResponseCR2k',
        //   JSON.stringify({ title: 'Redirected URL at outer iframe', URL: decodeURIComponent(url), currPath: decodeURIComponent(window.parent.location.href) }),
        // );
        this.$router.push(`${url.pathname}/${url.search}`);
      }
    });
  },
  destroyed() {
    window.removeEventListener('resize', this.resize);
  },
};
</script>

<style lang="sass">
@import '~bootstrap/scss/bootstrap.scss'
@import '~bootstrap-vue/src/index.scss'

.agile
  &__nav-button
    background: #fff
    border: 1px solid #4285f4
    color: #4285f4
    cursor: pointer
    font-size: 20px
    height: 40px
    position: absolute
    top: calc(50% - 40px)
    transition-duration: .3s
    width: 40px
    border-radius: 50%
    transition: 0.5s all

    &:hover
      border: none
      color: black
      box-shadow: gray -1px 1px 10px
      opacity: 1

    &--prev
      left: 0

    &--next
      right: 0

  &__dots
    bottom: 10px
    left: 50%
    position: absolute
    transform: translateX(-50%)

  &__dot
    margin: 0 10px

    button
      background-color: transparent
      border: 1px solid #fff
      border-radius: 50%
      cursor: pointer
      display: block
      height: 10px
      font-size: 0
      line-height: 0
      margin: 0
      padding: 0
      transition-duration: .3s
      width: 10px

    &--current,
    &:hover
      button
        background-color: #fff
</style>

<style>
@import '/assets/css/bonaufApp.css';

.bonauf-desktop::before {
  content: "";
  /* R5: removed the BO_NAUF.jpg fixed-position decorative palm tree image.
     On Galaxy Fold 7 (and other wide foldables) the device-detection picks
     "desktop" mode, which triggered this image as a 10%-opacity overlay
     covering the whole viewport — visible as faded palm trees behind the
     content. Nuked: display:none so no decorative bg leaks anywhere. */
  display: none !important;
  background: none !important;
  background-image: none !important;
}
.b-toaster-top-center .toast:not(.showing):not(.show) {
  opacity: 1;
}
.message-content {
  max-height: 6rem;
  overflow-y: auto;
}
.message-content p{
  margin: 0;
}
.message-content button{
  float:left;
}
#processingBooking + .modal-backdrop {
  opacity: 1;
  background-color: white;
}
#processingBooking .modal-content {
  box-shadow: #cac8c8 1px 1px 20px;
}
.accessibility_component > a.btn_accessibility.accessibility_component {
  /* display: none; */
  width: 80px;
  padding: 5px;
  height: 30px;
}
#processingBooking.ltr {
  direction: ltr;
}
#processingBooking.rtl {
  direction: rtl;
}
#processingBooking .modal-body h5 {
  padding: 35px 20px;
  font-size: 30px;
}
#processingBooking img {
  width: 200px;
  height: auto;
}
#processingBooking h3 {
  font-size: 22px;
  font-weight: 600;
  color: #313131;
  text-align: center;
}
#b-toaster-top-center {
  top: calc(50vh - 70px);
}
#processingBooking.modal .modal-dialog {
  display: flex;
  font-family: 'ploni', 'Poppins', sans-serif;
  font-weight: 500;
}
#processingBooking.modal:before {
  display: none;
}
#processingBooking.modal .modal-body {
  display: flex;
  padding: 0px;
  margin: 0px;
}
.carousel-indicators {
  bottom: -18px;
}
#statusSite {
  padding: 0 !important;
}
#statusSite .modal-header .close {
  padding: 0px;
  margin: 0;
}
@media (max-width:479px){
.carousel-indicators {
  bottom: 0;
}
  #processingBooking img {
    width: 100px;
    height: 100px;
  }
  #processingBooking .modal-body h5 {
    font-size: 22px;
  }
.accessibility_component > a.btn_accessibility.accessibility_component {
  width: 34px;
}
}
/* Global typography reset — overrides legacy body { font-family: "Open Sans Hebrew Condensed" } */
/* (the legacy font is not loaded; Latin fell through to system serif. Forcing ploni + Poppins.) */
html,
body,
input,
select,
textarea,
button,
h1, h2, h3, h4, h5, h6,
p, span, div, label, a,
figcaption, figure, li, ul, ol, td, th, dt, dd,
strong, em, b, small, blockquote, cite, q, sub, sup,
caption, summary, details, article, aside, header, footer,
section, main, nav {
  font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif;
}
/* But don't break Font Awesome icons — they need their own font-family */
i.fa, i.fas, i.far, i.fab, i.fal,
[class^="fa-"], [class*=" fa-"],
.fa, .fas, .far, .fab, .fal {
  font-family: "Font Awesome 5 Free", "Font Awesome 5 Brands", "FontAwesome" !important;
}

/* ====================================================================== */
/* R5 B28: Flight-only general terms accordion (matches premium pattern)   */
/* ====================================================================== */
.bnf-fo-terms-section {
  margin: 18px auto;
  padding: 0 8px;
}
.bnf-fo-terms-section .container {
  max-width: 720px;
  margin: 0 auto;
  background: #ffffff;
  border: 1px solid #e1e9f5;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.bnf-fo-terms-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: linear-gradient(180deg, #f7faff 0%, #eef6ff 100%);
  border: none;
  border-bottom: 1px solid #e1e9f5;
  font-size: 15px;
  font-weight: 700;
  color: #1c4e80;
  cursor: pointer;
  transition: background 0.18s ease;
  text-align: right;
}
.bnf-fo-terms-toggle:hover,
.bnf-fo-terms-toggle:focus {
  background: linear-gradient(180deg, #eef6ff 0%, #d6e9ff 100%);
  outline: none;
}
.bnf-fo-terms-toggle-text {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.bnf-fo-terms-toggle-text i {
  font-size: 14px;
  color: #1c7ed6;
}
.bnf-fo-terms-chevron {
  font-size: 12px;
  color: #1c7ed6;
  transition: transform 0.2s ease;
}
.bnf-fo-terms-section .bnf-general-terms-list {
  margin: 0 !important;
  padding: 8px 16px !important;
}

/* ====================================================================== */
/* R5 B29: Global premium flight-section heading (works on any page)       */
/* ====================================================================== */
.bnf-flight-section-heading {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 24px auto 16px !important;
  padding: 18px 60px !important;
  max-width: 720px;
  position: relative;
}
.bnf-flight-section-heading::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #1c7ed6 0%, #fb6d2f 100%);
  border-radius: 2px;
}
.bnf-flight-section-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #fff4ec 0%, #ffe6d3 100%);
  border: 2px solid #ffffff;
  box-shadow: 0 4px 12px rgba(251, 109, 47, 0.18), 0 0 0 4px rgba(251, 109, 47, 0.08);
}
.bnf-flight-section-icon i {
  font-size: 22px;
  color: #fb6d2f;
}
.bnf-flight-section-title {
  font-size: 22px !important;
  font-weight: 700 !important;
  color: #ffffff !important;
  margin: 0 0 6px !important;
  letter-spacing: 0.2px;
  line-height: 1.2 !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.45), 0 1px 2px rgba(0, 0, 0, 0.3);
  font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif !important;
}
.bnf-flight-section-subtitle {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
  margin: 0;
  line-height: 1.4;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}
@media (max-width: 479px) {
  .bnf-flight-section-heading {
    padding: 14px 40px !important;
  }
  .bnf-flight-section-icon {
    width: 44px;
    height: 44px;
    margin-bottom: 10px;
  }
  .bnf-flight-section-icon i {
    font-size: 18px;
  }
  .bnf-flight-section-title {
    font-size: 19px !important;
  }
  .bnf-flight-section-subtitle {
    font-size: 12px;
  }
}

/* ====================================================================== */
/* R5 B23: Premium section headings — booking page sections                */
/* (פרטי הנוסעים / כבודה / פרטי המשלם)                                    */
/* ====================================================================== */
.bnf-section-heading {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 24px auto 16px;
  padding: 18px 16px;
  max-width: 720px;
  position: relative;
}
.bnf-section-heading-spaced {
  margin-top: 36px;
}
.bnf-section-heading::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #1c7ed6 0%, #fb6d2f 100%);
  border-radius: 2px;
}
.bnf-section-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  margin-bottom: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #eef6ff 0%, #d6e9ff 100%);
  border: 2px solid #ffffff;
  box-shadow: 0 4px 12px rgba(28, 126, 214, 0.18), 0 0 0 4px rgba(28, 126, 214, 0.08);
}
.bnf-section-icon i {
  font-size: 20px;
  color: #1c7ed6;
}
/* Variant icons — different colors for visual rhythm */
.bnf-section-icon-baggage {
  background: linear-gradient(135deg, #fff4ec 0%, #ffe6d3 100%);
  box-shadow: 0 4px 12px rgba(251, 109, 47, 0.18), 0 0 0 4px rgba(251, 109, 47, 0.08);
}
.bnf-section-icon-baggage i {
  color: #fb6d2f;
}
.bnf-section-icon-payer {
  background: linear-gradient(135deg, #f0fdf4 0%, #c8e6c9 100%);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.18), 0 0 0 4px rgba(40, 167, 69, 0.08);
}
.bnf-section-icon-payer i {
  color: #28a745;
}
.bnf-section-title {
  font-size: 22px !important;
  font-weight: 700 !important;
  color: #ffffff !important;
  margin: 0 0 6px !important;
  letter-spacing: 0.2px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
  font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif !important;
}
.bnf-section-subtitle {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
  margin: 0;
  line-height: 1.4;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
@media (max-width: 479px) {
  .bnf-section-heading {
    margin: 20px auto 12px;
    padding: 14px 12px;
  }
  .bnf-section-heading-spaced {
    margin-top: 28px;
  }
  .bnf-section-icon {
    width: 44px;
    height: 44px;
    margin-bottom: 10px;
  }
  .bnf-section-icon i {
    font-size: 18px;
  }
  .bnf-section-title {
    font-size: 19px !important;
  }
  .bnf-section-subtitle {
    font-size: 12px;
  }
}

/* ====================================================================== */
/* R5 B19: Premium "general terms" list inside the collapsible panel.     */
/* ====================================================================== */
.bnf-general-terms-list {
  list-style: none !important;
  margin: 8px 0 0 !important;
  padding: 4px 0 !important;
  font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif !important;
  font-size: 13.5px;
  color: #334155;
  line-height: 1.55;
}
.bnf-general-terms-list li {
  position: relative;
  padding: 10px 26px 10px 6px !important;
  margin: 0 !important;
  border-bottom: 1px dashed #e3e9f1;
  list-style: none !important;
}
.bnf-general-terms-list li:last-child {
  border-bottom: none;
}
.bnf-general-terms-list li::before {
  content: '✓';
  position: absolute;
  right: 0;
  top: 10px;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1c7ed6 0%, #0061ab 100%);
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(28, 126, 214, 0.25);
}
.bnf-general-terms-list li strong {
  color: #0e436b;
  font-weight: 700;
  font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif !important;
}

/* ====================================================================== */
/* R5 Batch 17: Premium timeline for departure-list                        */
/* Replaces the legacy 50x50 circles + heavy dotted line with a clean     */
/* subtle timeline: thin vertical line + small brand-blue dots per item.  */
/* ====================================================================== */
.departure-list,
ul.departure-list {
  list-style: none !important;
  margin: 16px 0 !important;
  padding: 14px 36px 14px 18px !important;  /* extra padding-right for timeline gutter */
  background: linear-gradient(180deg, #f7faff 0%, #f0f5fc 100%);
  border: 1px solid #e1e9f5;
  border-radius: 12px;
  position: relative !important;
  font-size: 13px;
  color: #475569;
  line-height: 1.5;
}
/* Vertical line connecting the timeline dots */
.departure-list::before,
ul.departure-list::before {
  content: '' !important;
  position: absolute !important;
  top: 22px;
  bottom: 22px;
  right: 22px;
  width: 2px !important;
  height: auto !important;
  background: #cfe2ff !important;
  border: 0 !important;
  display: block !important;
}
/* Hide the legacy ::after on ul (some old global may have set one) */
.departure-list::after,
ul.departure-list::after {
  display: none !important;
  content: none !important;
}
/* Each item: small brand-blue dot on the right edge of the item */
.departure-list li,
ul.departure-list li {
  position: relative !important;
  padding: 8px 0 !important;
  margin: 0 !important;
  font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif !important;
  font-weight: 500;
  color: #334155 !important;
  border-bottom: 1px dashed #e3e9f1;
  list-style: none !important;
}
.departure-list li:last-child,
ul.departure-list li:last-child {
  border-bottom: none !important;
}
.departure-list li::before,
ul.departure-list li::before {
  content: '' !important;
  position: absolute !important;
  right: -16px;
  top: 14px;
  width: 10px !important;
  height: 10px !important;
  background: #1c7ed6 !important;
  border: 2px solid #ffffff !important;
  border-radius: 50% !important;
  box-shadow: 0 0 0 2px #cfe2ff !important;
  display: block !important;
}
/* First item dot: orange (departure) */
.departure-list li:first-child::before,
ul.departure-list li:first-child::before {
  background: #fb6d2f !important;
  box-shadow: 0 0 0 2px #ffe0cc !important;
}
/* Last item dot: green (arrival) */
.departure-list li:last-child::before,
ul.departure-list li:last-child::before {
  background: #28a745 !important;
  box-shadow: 0 0 0 2px #c8e6c9 !important;
}
/* Hide li::after (legacy big circles) — already done globally but reinforce */
.departure-list li::after,
ul.departure-list li::after {
  display: none !important;
  content: none !important;
  background: none !important;
  border: none !important;
  width: 0 !important;
  height: 0 !important;
}
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

/* Prevent horizontal overflow on mobile — content was bleeding past viewport on iPhone emulation. */
html, body {
  overflow-x: hidden;
  max-width: 100vw;
}
#app {
  max-width: 100vw;
  overflow-x: hidden;
}

/* ====================================================================== */
/* R5: Premium info icons GLOBALLY                                         */
/* The legacy "fa-exclamation-circle" / "fa-info-circle" icons rendered    */
/* inline-block with text-info bootstrap class — looked like raw chars.    */
/* Promote to circular brand-blue badges everywhere they appear in totals  */
/* and help contexts.                                                      */
/* ====================================================================== */
.bnf-info-badge,
button.bnf-totals-info,
.icon span.bnf-info-badge,
.icon i.fa-exclamation-circle.text-info,
.icon i.fa-info-circle.text-info {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #eef6ff;
  color: #1c7ed6 !important;
  border: 1px solid #cfe2ff;
  cursor: pointer;
  font-size: 14px !important;
  transition: background 0.2s ease, color 0.2s ease, transform 0.1s ease;
  text-decoration: none;
  vertical-align: middle;
  line-height: 1;
}
.bnf-info-badge:hover,
button.bnf-totals-info:hover,
.icon i.fa-exclamation-circle.text-info:hover,
.icon i.fa-info-circle.text-info:hover {
  background: #1c7ed6;
  color: #ffffff !important;
  transform: scale(1.05);
}
/* When the icon is inside an existing wrapper that itself is being styled
   as a button, prevent double-circling */
button.bnf-totals-info > i,
.bnf-info-badge > i {
  background: transparent !important;
  border: 0 !important;
  width: auto !important;
  height: auto !important;
  font-size: inherit !important;
  color: inherit !important;
}

/* ====================================================================== */
/* R5 Batch 12: .apparea was max-width: 479px in bonaufApp.css (forced     */
/* "phone-shaped" centered layout). On a real mobile this is fine because  */
/* viewport <= 479. But on wider mobile emulation / browser windows showing*/
/* the mobile UA, this leaves an empty gap on the left. Force 100% width   */
/* so content always reaches viewport edge.                                */
/* ====================================================================== */
/* ====================================================================== */
/* R5 Batch 15: ROOT CAUSE — RTL vertical scrollbar on the LEFT side       */
/* On RTL pages (dir="rtl" on <html>), Chrome puts the vertical scrollbar */
/* on the visual LEFT, consuming ~15-30px of width. This was the          */
/* persistent "white gap on left" — not a layout issue, the scrollbar     */
/* itself.                                                                 */
/* Fix: hide the native scrollbar (page still scrolls naturally via touch */
/* / wheel). Cross-browser: WebKit, Firefox, IE/Edge.                     */
/* ====================================================================== */
html {
  scrollbar-width: none;  /* Firefox */
  -ms-overflow-style: none;  /* IE / old Edge */
}
html::-webkit-scrollbar,
body::-webkit-scrollbar,
#app::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
}
/* Also flip the scrollbar to right side via direction trick — backup if
   the hide doesn't work in some browsers */
html {
  direction: rtl;
}
body {
  direction: rtl;
}

/* ====================================================================== */
/* R5 Batch 14: NUCLEAR full-width fix — no element below body may be      */
/* narrower than viewport. Also use dvw for foldable / dynamic viewports.  */
/* ====================================================================== */
html, body, #app {
  width: 100% !important;
  min-width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 0 !important;
  background: #ffffff !important;
  position: static !important;
  inset: auto !important;
  left: 0 !important;
  right: 0 !important;
  float: none !important;
  display: block !important;
}
/* Use dynamic viewport so Galaxy Fold inner screen, foldables, and
   browsers with dynamic URL bar all map width correctly */
html, body {
  width: 100dvw;
}

.apparea,
.apparea > div,
.apparea > section,
.apparea > main,
.apparea > .body_warrper,
.body_warrper,
.body_warrper > section {
  width: 100% !important;
  max-width: none !important;
  min-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  background: #ffffff;
  min-height: auto;
  float: none !important;
  display: block !important;
  position: relative;
  inset: auto !important;
  left: auto !important;
  right: auto !important;
}
.apparea {
  min-height: 100vh;
}
/* Keep individual content sections (cards, deal lists) to a sensible
   max width so they don't stretch awkwardly on wide views. */
.apparea > .body_warrper > section > .container,
.apparea > section > .container,
.apparea > div > section > .container {
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
}
/* The deal-filter pages have their own content wrapper; center those too */
.apparea .deals,
.apparea .filter-cont,
.apparea .deal-filter {
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

/* ====================================================================== */
/* R5 Batch 11: Cover the perspectiveBackground image bleed below kremlin  */
/* The booking page has a hero section with bg image; the image leaks past */
/* the kremlin-area2 down through following sections and shows around      */
/* the cards. Force a solid white bg from the body downwards.              */
/* ====================================================================== */
.apparea > .body_warrper > section:not(.kremlin-area):not(.banner-area),
.apparea > section:not(.kremlin-area):not(.banner-area),
.plainform-area,
.plainform-area2,
.plaindetails-area,
.flightdetails-area,
.order-area,
.paymentbox-area {
  background: #ffffff !important;
  position: relative;
}

/* On mobile, also tighten the Bootstrap .container side padding so the
   cards inside fit edge-to-edge — the image bg was peeking through the
   container's default 15px padding. */
@media (max-width: 768px) {
  .apparea .plainform-area > .container,
  .apparea .plainform-area2 > .container,
  .apparea .plaindetails-area > .container,
  .apparea .flightdetails-area > .container,
  .apparea .order-area > .container,
  .apparea .paymentbox-area > .container {
    padding-left: 8px;
    padding-right: 8px;
  }
}

/* ====================================================================== */
/* R5: Right-aligned placeholders for tel/email inputs                     */
/* type=tel/email default to LTR even on RTL pages — placeholder appears   */
/* on the visual left. Force right-align so Hebrew users see the           */
/* placeholder text where they expect it.                                  */
/* ====================================================================== */
.payer_detail input[type="tel"],
.payer_detail input[type="email"],
.pasenger_form input[type="tel"],
.pasenger_form input[type="email"],
.passenger_box input[type="tel"],
.passenger_box input[type="email"],
.passenger_box_two input[type="tel"],
.passenger_box_two input[type="email"] {
  text-align: right !important;
  direction: rtl !important;
}
/* But when user actually types digits/email, allow LTR text inside */
.payer_detail input[type="tel"]:not(:placeholder-shown),
.payer_detail input[type="email"]:not(:placeholder-shown),
.pasenger_form input[type="tel"]:not(:placeholder-shown),
.pasenger_form input[type="email"]:not(:placeholder-shown),
.passenger_box input[type="tel"]:not(:placeholder-shown),
.passenger_box input[type="email"]:not(:placeholder-shown),
.passenger_box_two input[type="tel"]:not(:placeholder-shown),
.passenger_box_two input[type="email"]:not(:placeholder-shown) {
  text-align: right !important;
  direction: ltr !important;
  unicode-bidi: plaintext;
}

/* ====================================================================== */
/* R5: Hide premature validation error messages                            */
/* Show inline errors only after the user blurred or typed something       */
/* (i.e., the input is no longer in its initial pristine state).           */
/* ====================================================================== */
.invalid-feedback,
.invalid-feedback.d-block {
  display: none !important;
}
.form-control.is-invalid:not(:placeholder-shown) ~ .invalid-feedback,
.form-control.danger:not(:placeholder-shown) ~ .invalid-feedback,
.form-control:invalid:not(:placeholder-shown) ~ .invalid-feedback,
.form-control:focus.is-invalid ~ .invalid-feedback {
  display: block !important;
  color: #b91c1c;
  font-size: 12px;
  font-weight: 500;
  margin-top: 4px;
  text-align: right;
}

/* ====================================================================== */
/* R5: Trust signals strip — uniform prominence across all pages           */
/* Bigger icons, slightly larger font, better breathing room               */
/* ====================================================================== */
.trust-signals,
.trust-signals-section .trust-signals {
  font-size: 13px !important;
  font-weight: 600 !important;
  padding: 12px 16px !important;
  gap: 16px !important;
  margin: 12px auto !important;
  max-width: 720px !important;
  background: linear-gradient(180deg, #f7faff 0%, #eef6ff 100%) !important;
  border: 1px solid #cfe2ff !important;
  border-radius: 12px !important;
  box-shadow: 0 1px 4px rgba(0, 97, 171, 0.06) !important;
}
.trust-signals .trust-item i,
.trust-signals-section .trust-item i {
  width: 22px !important;
  height: 22px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #ffffff;
  border-radius: 50%;
  color: #1c7ed6 !important;
  font-size: 11px !important;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}
.trust-signals .trust-item,
.trust-signals-section .trust-item {
  color: #1c4e80 !important;
  font-weight: 600 !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 7px !important;
}
@media (max-width: 479px) {
  .trust-signals,
  .trust-signals-section .trust-signals {
    font-size: 11px !important;
    padding: 10px 12px !important;
    gap: 10px !important;
    margin: 10px 12px !important;
  }
  .trust-signals .trust-item i,
  .trust-signals-section .trust-item i {
    width: 18px !important;
    height: 18px !important;
    font-size: 10px !important;
  }
}

/* ====================================================================== */
/* R5: Premium restyle for bootstrap-datetimepicker (DOB picker)           */
/* The legacy widget rendered like a 2015 Bootstrap calendar — flat,       */
/* gray, dense. Re-skin with brand-blue, soft borders, rounded corners.    */
/* ====================================================================== */
.bootstrap-datetimepicker-widget {
  font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif !important;
  background: #ffffff !important;
  border: 1px solid #e3e9f1 !important;
  border-radius: 14px !important;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.06) !important;
  padding: 8px !important;
  min-width: 280px !important;
}
.bootstrap-datetimepicker-widget.dropdown-menu {
  margin-top: 6px;
}
.bootstrap-datetimepicker-widget table {
  border-collapse: separate !important;
  border-spacing: 4px !important;
}
.bootstrap-datetimepicker-widget table th,
.bootstrap-datetimepicker-widget table td {
  border-radius: 8px !important;
  border: 0 !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  text-align: center;
}
/* Header row (month label + arrows) */
.bootstrap-datetimepicker-widget .picker-switch,
.bootstrap-datetimepicker-widget table th.picker-switch {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #0e436b !important;
  background: transparent !important;
  text-transform: capitalize;
  padding: 8px 4px !important;
}
.bootstrap-datetimepicker-widget table th.prev,
.bootstrap-datetimepicker-widget table th.next {
  color: #1c7ed6 !important;
  font-size: 18px !important;
  cursor: pointer;
  background: transparent !important;
  border-radius: 50% !important;
  width: 32px !important;
  height: 32px !important;
  line-height: 32px !important;
  transition: background 0.15s ease;
}
.bootstrap-datetimepicker-widget table th.prev:hover,
.bootstrap-datetimepicker-widget table th.next:hover {
  background: #eef6ff !important;
}
/* Day-of-week header (Sun/Mon/...) */
.bootstrap-datetimepicker-widget table th.dow {
  color: #94a3b8 !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  text-transform: uppercase;
  padding: 6px 0 !important;
  border-bottom: 1px solid #f1f5f9 !important;
}
/* Day cells */
.bootstrap-datetimepicker-widget td.day,
.bootstrap-datetimepicker-widget td.hour,
.bootstrap-datetimepicker-widget td.minute,
.bootstrap-datetimepicker-widget td.year,
.bootstrap-datetimepicker-widget td span.month,
.bootstrap-datetimepicker-widget td span.year {
  color: #0e436b !important;
  background: transparent !important;
  cursor: pointer;
  width: 36px !important;
  height: 36px !important;
  line-height: 36px !important;
  padding: 0 !important;
  transition: background 0.15s ease, color 0.15s ease, transform 0.1s ease;
}
.bootstrap-datetimepicker-widget td.day:hover,
.bootstrap-datetimepicker-widget td.hour:hover,
.bootstrap-datetimepicker-widget td.minute:hover,
.bootstrap-datetimepicker-widget td.year:hover,
.bootstrap-datetimepicker-widget td span.month:hover,
.bootstrap-datetimepicker-widget td span.year:hover {
  background: #eef6ff !important;
  color: #1c4e80 !important;
}
.bootstrap-datetimepicker-widget td.old,
.bootstrap-datetimepicker-widget td.new,
.bootstrap-datetimepicker-widget td span.old,
.bootstrap-datetimepicker-widget td span.new {
  color: #cbd5e1 !important;
}
/* Selected state — brand-blue gradient pill */
.bootstrap-datetimepicker-widget td.day.active,
.bootstrap-datetimepicker-widget td.day.active:hover,
.bootstrap-datetimepicker-widget td.hour.active,
.bootstrap-datetimepicker-widget td.minute.active,
.bootstrap-datetimepicker-widget td.year.active,
.bootstrap-datetimepicker-widget td span.month.active,
.bootstrap-datetimepicker-widget td span.year.active {
  background: linear-gradient(135deg, #0061ab 0%, #1c7ed6 100%) !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 2px 6px rgba(28, 126, 214, 0.32);
}
/* Today */
.bootstrap-datetimepicker-widget td.today:not(.active) {
  position: relative;
  font-weight: 700 !important;
  color: #1c7ed6 !important;
}
.bootstrap-datetimepicker-widget td.today:not(.active)::after {
  content: '' !important;
  position: absolute !important;
  bottom: 4px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: 4px !important;
  height: 4px !important;
  background: #1c7ed6 !important;
  border-radius: 50% !important;
  border: 0 !important;
  top: auto !important;
}
/* Disabled days */
.bootstrap-datetimepicker-widget td.disabled,
.bootstrap-datetimepicker-widget td.disabled:hover,
.bootstrap-datetimepicker-widget td span.disabled {
  color: #cbd5e1 !important;
  background: transparent !important;
  cursor: not-allowed;
}
/* Months/Years grids — sized boxes */
.bootstrap-datetimepicker-widget td span.month,
.bootstrap-datetimepicker-widget td span.year {
  width: 60px !important;
  height: 42px !important;
  line-height: 42px !important;
  margin: 4px 2px !important;
  border-radius: 8px !important;
  font-size: 13px !important;
}
/* Time picker section — refined */
.bootstrap-datetimepicker-widget a.btn[data-action]:hover {
  background: #eef6ff !important;
  color: #1c7ed6 !important;
}

#app {
  font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif;
  text-align: right;
  height: 100%;
}
#app.has-background {
  background-image: url('https://cdn.speedsize.com/05b4c650-ae31-47ac-b679-5cd058f0cc68/https://www.flying.co.il/assets/img/banner_landing.jpg');
  background-repeat: no-repeat;
  background-size: cover;
}
html {
  scroll-behavior: smooth;
}
#nprogress .bar {
  background: rgb(0, 255, 149) !important;
  height: 5px;
}
#nprogress .peg {
  box-shadow: 0 0 10px rgb(0, 255, 149), 0 0 5px rgb(0, 255, 149) !important;
}
#nprogress .spinner-icon {
  border-top-color: rgb(0, 255, 149) !important;
  border-left-color: rgb(0, 255, 149) !important;
}
/* .st-content{
  scroll-behavior: smooth;
} */

.b-toast .toast .toast-bod.ltr {
  direction: ltr;
}

.b-toast .toast .toast-bod.rtl {
  direction: rtl;
}
</style>
